// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cards .card .actions[data-v-1492a5f2] {\n  width: 30px;\n}\n.cards .card .actions i[data-v-1492a5f2] {\n  cursor: pointer;\n}\n.description[data-v-1492a5f2] {\n  padding: 17px 0px;\n}\n.description h4[data-v-1492a5f2],\n.description h5[data-v-1492a5f2] {\n  margin: 0;\n  overflow-wrap: break-word;\n}\n[data-v-1492a5f2] .sida-modal {\n  max-width: 700px;\n}\n[data-v-1492a5f2] .sida-modal .modal-content {\n  height: 330px;\n}\n", ""]);
// Exports
module.exports = exports;
